/**
 * Generates Tailwind-style color shades from a base hex color
 * Returns shades from 50 to 900
 */
export class ColorShadeUtility {
  static generateShades(hexColor: string): Record<number, string> {
    const hex = hexColor.replace('#', '');
    const [r, g, b] = this.hexToRgb(hex);

    return {
      50: this.rgbToHex(this.lighten([r, g, b], 0.95)),
      100: this.rgbToHex(this.lighten([r, g, b], 0.9)),
      200: this.rgbToHex(this.lighten([r, g, b], 0.75)),
      300: this.rgbToHex(this.lighten([r, g, b], 0.6)),
      400: this.rgbToHex(this.lighten([r, g, b], 0.3)),
      500: `#${hex.toUpperCase()}`,
      600: this.rgbToHex(this.darken([r, g, b], 0.1)),
      700: this.rgbToHex(this.darken([r, g, b], 0.2)),
      800: this.rgbToHex(this.darken([r, g, b], 0.3)),
      900: this.rgbToHex(this.darken([r, g, b], 0.4)),
    };
  }

  private static hexToRgb(hex: string): [number, number, number] {
    const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!result) return [0, 0, 0];
    return [
      parseInt(result[1], 16),
      parseInt(result[2], 16),
      parseInt(result[3], 16),
    ];
  }

  private static rgbToHex(rgb: [number, number, number]): string {
    return (
      '#' +
      rgb
        .map((x) => {
          const hex = Math.round(Math.max(0, Math.min(255, x))).toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        })
        .join('')
        .toUpperCase()
    );
  }

  private static lighten(rgb: [number, number, number], amount: number): [number, number, number] {
    return [
      Math.round(rgb[0] + (255 - rgb[0]) * amount),
      Math.round(rgb[1] + (255 - rgb[1]) * amount),
      Math.round(rgb[2] + (255 - rgb[2]) * amount),
    ];
  }

  private static darken(rgb: [number, number, number], amount: number): [number, number, number] {
    return [
      Math.round(rgb[0] * (1 - amount)),
      Math.round(rgb[1] * (1 - amount)),
      Math.round(rgb[2] * (1 - amount)),
    ];
  }
}
